<!-- eslint-disable --> <!-- todo: check but probably select will be moved to prime implementation -->
<div class="cw-md-select">
    <cw-input
            #input
            [cw-label]="label"
            [cw-readonly]="true"
            class="cw-md-select__input"
            [ngModel]="inputValue"
    />
    <div class="cw-md-select__overlay" (click)="openList()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <i class="material-icons cw-md-select__arrow">expand_more</i>
    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isExpanded"
                 [cdkConnectedOverlayWidth]="overlayWidth">
        <div class="cw-md-select__list-container cw-md-layout cw-md-layout--column">
            <ng-content />
        </div>
    </ng-template>
</div>
